import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", () => {
  const notification = document.querySelector(".notification");
  const closeNotification = document.querySelector(".notification-close");

  // Only proceed if both elements exist
  if (!notification || !closeNotification) return;

  const cookieValue = notificationData.cookieValue; // set in functions.php

  // check if cookie is set
  if (Cookies.get(cookieValue)) {
    notification.classList.add("notification--inactive");
  }

  // close notification
  closeNotification.addEventListener("click", () => {
    notification.classList.add("notification--inactive");

    // never expire
    Cookies.set(cookieValue, "true", { expires: 365 });
  });
});

// clear cookie
// Cookies.remove(cookieValue);
